// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   BANDEJA DE ENTRADA — Estilos (alineados con Bandeja de Requerimientos)
   ============================================================ */

.bandeja-entrada {
  padding: 32px 32px 40px;
  max-width: 1500px;
  margin: 0 auto;
  animation: fadeInUp 0.5s ease;
}

/* ── Título principal ── */
.bandeja-entrada-titulo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 28px;
  color: var(--text);
  font-size: 26px;
  font-weight: 800;
  letter-spacing: -0.5px;
}

.bandeja-entrada-titulo .titulo-icono {
  font-size: 28px;
}

/* ── Contenedor principal de tabla ── */
.be-table-wrapper {
  background: var(--bg-card);
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}

/* ── Header del card ── */
.be-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  background: var(--bg-subtle);
  border-bottom: 1px solid var(--border);
}

.be-card-header h3 {
  font-size: 15px;
  font-weight: 700;
  color: var(--text);
  margin: 0;
}

.be-count-pill {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--text-muted);
  background: var(--bg);
  padding: 4px 12px;
  border-radius: var(--radius-full);
  letter-spacing: 0.3px;
}

/* ── Barra de búsqueda ── */
.be-search-bar {
  padding: 14px 24px;
  border-bottom: 1px solid var(--border-light);
  background: var(--bg-card);
}

.be-search-input {
  width: 100%;
  max-width: 400px;
  padding: 9px 14px;
  border-radius: 8px;
  border: 1px solid var(--border);
  outline: none;
  font-size: 14px;
  font-family: var(--font-sans);
  transition: var(--transition);
  background-color: var(--bg-card);
  color: var(--text);
}

.be-search-input:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--primary-ultralight);
}

/* ── Tabla ── */
.be-table-responsive {
  overflow-x: auto;
  width: 100%;
}

.be-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

/* Cabecera */
.be-table thead tr {
  background: var(--bg-card);
  border-bottom: 2px solid var(--border);
}

.be-table thead th {
  padding: 12px 16px;
  text-align: center;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: var(--text-muted);
  white-space: nowrap;
}

/* Filas del cuerpo */
.be-table tbody tr {
  border-bottom: 1px solid var(--border-light);
  transition: background var(--transition-fast);
}

.be-table tbody tr:last-child {
  border-bottom: none;
}

.be-table tbody tr:hover {
  background: var(--primary-50);
}

.be-table tbody td {
  padding: 14px 16px;
  color: var(--text-secondary);
  vertical-align: middle;
}

/* ── Identificador ── */
.be-id-cell {
  font-weight: 700;
  color: var(--primary);
  font-size: 13px;
  white-space: nowrap;
}

[data-theme="dark"] .be-id-cell {
  color: #ffffff;
}

/* ── Monto ── */
.be-monto-cell {
  font-weight: 600;
  color: #0f766e;
  white-space: nowrap;
}

/* ── Badges estado ── */
.be-estado-badge {
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: var(--radius-full);
  font-size: 12px;
  font-weight: 600;
  color: #ffffff;
  white-space: nowrap;
}

/* ── Acciones ── */
.be-btn-link {
  color: var(--primary);
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  padding: 4px 0;
  transition: color var(--transition-fast);
  white-space: nowrap;
}

[data-theme="dark"] .be-btn-link {
  color: #ffffff;
}

.be-btn-link:hover {
  color: var(--primary-light);
  text-decoration: underline;
}

/* ── Estado vacío ── */
.be-empty-state {
  padding: 56px 24px;
  text-align: center;
}

.be-empty-state p {
  color: var(--text-muted);
  font-size: 15px;
}

/* ── Barra de paginación ── */
.be-pagination-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 24px;
  border-top: 1px solid var(--border-light);
  background: var(--bg-card);
}

.be-pagination-btn {
  padding: 8px 18px;
  border-radius: 6px;
  border: 1px solid var(--border);
  background: var(--bg-card);
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  font-family: var(--font-sans);
  color: var(--text);
  transition: var(--transition);
}

.be-pagination-btn:hover:not(:disabled) {
  background: var(--bg-subtle);
  border-color: var(--border);
}

.be-pagination-btn:disabled {
  background: var(--bg-subtle);
  color: var(--text-muted);
  cursor: not-allowed;
  border-color: var(--border-light);
}

.be-pagination-info {
  font-size: 14px;
  color: var(--text-secondary);
  font-weight: 500;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .bandeja-entrada {
    padding: 16px;
  }

  .bandeja-entrada-titulo {
    font-size: 22px;
  }

  .be-card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .be-search-input {
    max-width: 100%;
  }

  .be-pagination-bar {
    flex-direction: column;
    gap: 16px;
  }

  .be-pagination-btn {
    width: 100%;
  }

  .be-table thead th,
  .be-table tbody td {
    padding: 10px 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/BandejaEntrada.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE;EACE,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,4CAA4C;EAC5C,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,kBAAkB;EACpB;AACF","sourcesContent":["/* ============================================================\n   BANDEJA DE ENTRADA — Estilos (alineados con Bandeja de Requerimientos)\n   ============================================================ */\n\n.bandeja-entrada {\n  padding: 32px 32px 40px;\n  max-width: 1500px;\n  margin: 0 auto;\n  animation: fadeInUp 0.5s ease;\n}\n\n/* ── Título principal ── */\n.bandeja-entrada-titulo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 28px;\n  color: var(--text);\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n}\n\n.bandeja-entrada-titulo .titulo-icono {\n  font-size: 28px;\n}\n\n/* ── Contenedor principal de tabla ── */\n.be-table-wrapper {\n  background: var(--bg-card);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n}\n\n/* ── Header del card ── */\n.be-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 18px 24px;\n  background: var(--bg-subtle);\n  border-bottom: 1px solid var(--border);\n}\n\n.be-card-header h3 {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--text);\n  margin: 0;\n}\n\n.be-count-pill {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  background: var(--bg);\n  padding: 4px 12px;\n  border-radius: var(--radius-full);\n  letter-spacing: 0.3px;\n}\n\n/* ── Barra de búsqueda ── */\n.be-search-bar {\n  padding: 14px 24px;\n  border-bottom: 1px solid var(--border-light);\n  background: var(--bg-card);\n}\n\n.be-search-input {\n  width: 100%;\n  max-width: 400px;\n  padding: 9px 14px;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  outline: none;\n  font-size: 14px;\n  font-family: var(--font-sans);\n  transition: var(--transition);\n  background-color: var(--bg-card);\n  color: var(--text);\n}\n\n.be-search-input:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px var(--primary-ultralight);\n}\n\n/* ── Tabla ── */\n.be-table-responsive {\n  overflow-x: auto;\n  width: 100%;\n}\n\n.be-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n/* Cabecera */\n.be-table thead tr {\n  background: var(--bg-card);\n  border-bottom: 2px solid var(--border);\n}\n\n.be-table thead th {\n  padding: 12px 16px;\n  text-align: center;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: var(--text-muted);\n  white-space: nowrap;\n}\n\n/* Filas del cuerpo */\n.be-table tbody tr {\n  border-bottom: 1px solid var(--border-light);\n  transition: background var(--transition-fast);\n}\n\n.be-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.be-table tbody tr:hover {\n  background: var(--primary-50);\n}\n\n.be-table tbody td {\n  padding: 14px 16px;\n  color: var(--text-secondary);\n  vertical-align: middle;\n}\n\n/* ── Identificador ── */\n.be-id-cell {\n  font-weight: 700;\n  color: var(--primary);\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n[data-theme=\"dark\"] .be-id-cell {\n  color: #ffffff;\n}\n\n/* ── Monto ── */\n.be-monto-cell {\n  font-weight: 600;\n  color: #0f766e;\n  white-space: nowrap;\n}\n\n/* ── Badges estado ── */\n.be-estado-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 5px 12px;\n  border-radius: var(--radius-full);\n  font-size: 12px;\n  font-weight: 600;\n  color: #ffffff;\n  white-space: nowrap;\n}\n\n/* ── Acciones ── */\n.be-btn-link {\n  color: var(--primary);\n  font-size: 13px;\n  font-weight: 600;\n  text-decoration: none;\n  padding: 4px 0;\n  transition: color var(--transition-fast);\n  white-space: nowrap;\n}\n\n[data-theme=\"dark\"] .be-btn-link {\n  color: #ffffff;\n}\n\n.be-btn-link:hover {\n  color: var(--primary-light);\n  text-decoration: underline;\n}\n\n/* ── Estado vacío ── */\n.be-empty-state {\n  padding: 56px 24px;\n  text-align: center;\n}\n\n.be-empty-state p {\n  color: var(--text-muted);\n  font-size: 15px;\n}\n\n/* ── Barra de paginación ── */\n.be-pagination-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 24px;\n  border-top: 1px solid var(--border-light);\n  background: var(--bg-card);\n}\n\n.be-pagination-btn {\n  padding: 8px 18px;\n  border-radius: 6px;\n  border: 1px solid var(--border);\n  background: var(--bg-card);\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 13px;\n  font-family: var(--font-sans);\n  color: var(--text);\n  transition: var(--transition);\n}\n\n.be-pagination-btn:hover:not(:disabled) {\n  background: var(--bg-subtle);\n  border-color: var(--border);\n}\n\n.be-pagination-btn:disabled {\n  background: var(--bg-subtle);\n  color: var(--text-muted);\n  cursor: not-allowed;\n  border-color: var(--border-light);\n}\n\n.be-pagination-info {\n  font-size: 14px;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n/* ── Responsive ── */\n@media (max-width: 768px) {\n  .bandeja-entrada {\n    padding: 16px;\n  }\n\n  .bandeja-entrada-titulo {\n    font-size: 22px;\n  }\n\n  .be-card-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .be-search-input {\n    max-width: 100%;\n  }\n\n  .be-pagination-bar {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .be-pagination-btn {\n    width: 100%;\n  }\n\n  .be-table thead th,\n  .be-table tbody td {\n    padding: 10px 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
